export default "__VITE_ASSET__BGmAOLCh__"